import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import DropdownIcon from "assets/icons/dropdown.inline.svg";
import CheckboxItem from "./FilterCheckboxItem";

const FilterSection = ({
	id,
	title,
	items,
	onItemChange,
	collapsed = false,
	onToggle = undefined,
	activeCount = 0,
	inputType = "checkbox",
	disabled = false
}) => (
	<section
		className={classNames("filters__section", {
			"filters__section--collapsed": collapsed,
			"filters__section--disabled": disabled
		})}
	>
		<button
			type="button"
			className="filters__section-header"
			onClick={onToggle}
			aria-expanded={!collapsed}
			aria-controls={`filters-section-${id}`}
		>
			<span className="filters__section-header-left">
				<DropdownIcon
					className={classNames("filters__section-arrow", {
						"filters__section-arrow--collapsed": collapsed
					})}
					aria-hidden="true"
				/>
				<span className="filters__section-title">{title}</span>
			</span>
			{activeCount > 0 && (
				<span className="filters__section-badge">{activeCount}</span>
			)}
		</button>
		<fieldset
			id={`filters-section-${id}`}
			className="filters__fieldset"
		>
			<legend className="filters__section-legend">{title}</legend>
			{items.map((item) => (
				<CheckboxItem
					key={item.id}
					id={item.id}
					label={item.label}
					name={item.name}
					value={item.value}
					checked={item.checked}
					onChange={() => onItemChange(id, item.id)}
					type={inputType}
					disabled={disabled || item.disabled}
				/>
			))}
		</fieldset>
	</section>
);

FilterSection.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			checked: PropTypes.bool,
			disabled: PropTypes.bool
		})
	).isRequired,
	onItemChange: PropTypes.func.isRequired,
	collapsed: PropTypes.bool,
	onToggle: PropTypes.func,
	activeCount: PropTypes.number,
	inputType: PropTypes.oneOf(["checkbox", "radio"]),
	disabled: PropTypes.bool
};

export default FilterSection;
